module.exports = __webpack_public_path__ + "media/components/src/assets/images/image_text2/15-1916f6a0bd14aaa9be17f170dff3b31f.jpg";